<!-- Switcher -->
<template>
    <div class="fixed top-1/4 -right-1 z-3">
<span class="relative inline-block rotate-90">
        <input type="checkbox" class="absolute opacity-0 checkbox" id="chk" />
        <label class="flex items-center justify-between h-8 p-1 rounded-full shadow cursor-pointer label bg-slate-900 w-14" for="chk">
            <i class="uil uil-moon text-[20px] text-yellow-500"></i>
            <i class="uil uil-sun text-[20px] text-yellow-500"></i>
            <span class="ball bg-white rounded-full absolute top-[2px] left-[2px] w-7 h-7"></span>
        </label>
    </span>
    </div>
</template>
<!-- Switcher -->

<script>
export default {

}
</script>
